import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopoverDirective, NzPopoverModule } from 'ng-zorro-antd/popover';
import { IDocumentCard, IDocumentEmitter } from '../../interfaces/document-card.interface';

@Component({
  selector: 'app-document-card',
  standalone: true,
  imports: [CommonModule, NzGridModule, NzIconModule, TranslateModule, NzPopoverModule],
  templateUrl: './document-card.component.html',
  styleUrl: './document-card.component.scss',
})
export class DocumentCardComponent {
  @Input({ required: true }) documentCardData?: IDocumentCard;
  @Input() isPopoverVisible: boolean = true;

  @Output() emitActionCard: EventEmitter<IDocumentEmitter> = new EventEmitter();

  protected handleActionCard(documentSelected: IDocumentEmitter): void {
    this.emitActionCard.emit(documentSelected);
  }

  protected closePopover(popover: NzPopoverDirective): void {
    popover.hide();
  }
}
